import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { AuthService } from "src/app/auth/service/auth/auth.service";
import { BreadcrumbService } from "src/app/layout/service/breadcrumb/breadcrumb.service";
import { componentDisplayEntityMap } from "src/app/shared/constant/component-entity-map";
import { ENVIRONMENT, SUB_DOMAIN, TOPBAR_LOGO_URL } from "src/app/shared/constant/constant";
import { CrossStorageService } from "src/app/shared/service/cross-storage/cross-storage.service";
import { UserService } from "src/app/shared/service/user/user.service";
import { SubSink } from "subsink";
import { DatePipe } from '@angular/common';
import { interval, Subscription } from 'rxjs';
import { AppService } from "src/app/app.service";
import { AppConfigurationService } from "src/app/shared/service/app-configuration/app-configuration.service";
import { HttpclientService } from "src/app/shared/service/httpclient/httpclient.service";
@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.css"],
})
export class TopbarComponent implements OnInit {
  private subs = new SubSink();

  userName: string;
  logoUrl: string;
  breadcrumbPrefixUrl: string;
  breadcrumbPrefixLabel: string;
  breadcrumbUrl: string;
  breadcrumbLabel: string;
  lobId: number;
  currentDateAndTime: string;
  environmentType: string = '';
  environmentTypeColor: string = '';
  environmentTypeAvailable: boolean = false;
  environment: string;
  reserveConfigurationJSON: any;
 
  subscription: Subscription;
  urlMap = new Map<string, string>([
    ['admin', 'admin/client'],
    ['ur', 'ur/util-search'],
    ['request', 'request/req-summary'],
    ['um', 'um/user-details'],
    ['user', 'user/user-management'],
    ['client', 'client/client-details'],
    ['home', 'home/my-claims']
  ])

  homeUrlsList = ['user'];

  constructor(
    private router: Router,
    private authService: AuthService,
    private _userService: UserService,
    private httpClientService: HttpclientService,
    private breadcrumbService: BreadcrumbService,
    private crossStorageService: CrossStorageService,
    private datePipe: DatePipe,
    private appService: AppService,
    private appConfigService: AppConfigurationService
  ) {
    this.userName = this._userService.getUserName();
    this.lobId = sessionStorage.getItem("lobId") ? parseInt(sessionStorage.getItem("lobId")) : 0;
  }

  ngOnInit(): void {
    let client = this.appService.getClientName();
    this.environment = localStorage.getItem(ENVIRONMENT);
    const subdomain: string = this.appService.getCurrentSubDomain();
    this.logoUrl = this.appConfigService.getAppLogo(this.environment, client);
    this.subscribeToBreadcrumb();
    this.currentDateAndTime = this.datePipe.transform(new Date(), 'MM-dd-yyyy HH:mm');
    this.updateCurrentDateTime();
    this.getRibbonData();
    this.subscription = interval(1000) // Update every second
      .subscribe(() => this.updateCurrentDateTime());
  }
  updateCurrentDateTime() {
    this.currentDateAndTime = this.datePipe.transform(new Date(), 'MM-dd-yyyy HH:mm');
  }
  subscribeToBreadcrumb() {
    this.subs.sink = this.breadcrumbService.url$.subscribe(
      (next) => (this.breadcrumbUrl = next)
    );
    this.subs.sink = this.breadcrumbService.label$.subscribe(
      (next) => (this.breadcrumbLabel = next)
    );
    this.subs.sink = this.breadcrumbService.prefixUrl$.subscribe(
      next => { this.breadcrumbPrefixUrl = next }
    )
    this.subs.sink = this.breadcrumbService.prefixLabel$.subscribe(
      next => { this.breadcrumbPrefixLabel = next }
    )
  }

  isComponentEntityDisplayed(): boolean {
    return this.homeUrlsList.indexOf(this.getBaseRoute()) === -1;
  }

  getComponentEntityLabel(): string {
    let entityTypeId = sessionStorage.getItem("ENTITY_TYPE_ID");
    if (entityTypeId == "1") {
      return sessionStorage.getItem("SEL_USER_NAME");
    } else if (entityTypeId == "2") {
      return sessionStorage.getItem("SEL_TEMP_NAME");
    }
  }

  getRibbonData() {
    this.subs.sink = this.httpClientService.post("getribbonconfigurationdetails").subscribe(
      data => {
        if (data.ok) {
          this.reserveConfigurationJSON = data.responseData.reserveConfiguration;
          this.environmentType = this.reserveConfigurationJSON?.environmentType;
          this.environmentTypeColor = this.reserveConfigurationJSON?.environmentTypeColor || '#000000';
          this.environmentTypeAvailable = true;
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  getBaseRoute() {
    const url = this.router.url.split('/');
    const baseRoute = url[1];
    return baseRoute;
  }

  getDefaultRoute() {
    let defRoute = sessionStorage.getItem("defaultRoute");
    if (defRoute == '' || defRoute == null || defRoute == undefined) {
      defRoute = this.getBaseRoute();
    }
    return defRoute;
  }

  onClickChield() {
    sessionStorage.getItem("dcomponentId") ? sessionStorage.setItem("SEL_COMP_ID", sessionStorage.getItem("dcomponentId")) : '';
  }

  showHomeMenu(): boolean {
    const url = this.router.url.split('/');
    const baseRoute = url[1];
    url.shift();
    const subRoute = url.join('/');
    return (subRoute != this.urlMap.get(baseRoute));
  }

  onClickSidebarToggle() {
    const body = document.getElementsByTagName('body')[0]
    const sidebar = document.getElementsByClassName('sidebar')[0]
    if (body.classList.contains('sidebar-toggled')) {
      body.classList.remove('sidebar-toggled')
      sidebar.classList.remove('toggled')
    } else {
      body.classList.add('sidebar-toggled')
      sidebar.classList.add('toggled')
    }
  }

  logout() {
    this.subs.sink = this.authService.logout().subscribe((res) => { });
    this.crossStorageService.logout();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  getRedPath() {
    let redUrl;

    if (this.getBaseRoute() == "claim") {
      redUrl = this.lobId == 1 ? "/claim/claim-summary-gl" : "/claim/claim-summary";
    } else {
      redUrl = this.urlMap.get(this.getBaseRoute());
    }
    return redUrl;
  }
}
